import constants from '~/src/constants';

export default {
  'back-button': `Retour vers ${constants.baseDomainUrl}`,
};
